import React from 'react';
import { Card, CardActions, CardText } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button } from 'react-toolbox/lib/button';
import Dropdown from 'react-toolbox/lib/dropdown';
import Checkbox from 'react-toolbox/lib/checkbox';

import { listUsers } from '~/actions/user';
import { orderRefreshByInvoiceId } from '~/actions/orders';
import dynamicSort from '~/utils/dynamicSort';
import Create from './create';
import Edit from './edit';
import Styles from './users.scss';

const orderByStates = [
  { value: 'username', label: 'Username' },
  { value: 'name', label: 'Name' },
  { value: 'level', label: 'Level' }
];

const levels = {
  1: 'SuperAdmin',
  10: 'Admin',
  1500: 'Manager',
  2000: 'Users',
  2001: 'System'
};

class Users extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      showCreate: false,
      showEdit: false,
      showInactiveUsers: false,
      orderBy: 'username',
      curUser: false,
      search: '',
      invoiceId: ''
    };
  }
  componentDidMount() {
    listUsers(this.props.dispatch, this.context.apiClient);
  }
  toggleEdit() {
    this.setState({ showEdit: !this.state.showEdit });
  }
  toggleCreate() {
    this.setState({ showCreate: !this.state.showCreate });
  }
  editUser(user) {
    this.setState({ showEdit: true, curUser: user });
  }
  fetchOrder() {
    const { invoiceId } = this.state;
    orderRefreshByInvoiceId(
      this.props.dispatch,
      this.context.apiClient,
      invoiceId
    );
    console.log(invoiceId);
  }
  renderUsers(users) {
    const { search, showInactiveUsers } = this.state;
    const seekRegex = new RegExp(search, 'i');

    return users.map(item => {
      const inactive = item.status === 'inactive';
      if (seekRegex.exec(item.name) && (!inactive || showInactiveUsers)) {
        return (
          <tr key={item.userId}>
            <td>
              <div className={Styles.spacer} />
            </td>
            <td>{item.username}</td>
            <td>{item.name}</td>
            <td>{levels[item.level]}</td>
            <td>{item.status}</td>
            <td>
              <Button
                icon="edit"
                label="Edit user"
                raised
                primary
                onClick={() => {
                  this.editUser(item);
                }}
              />
            </td>
          </tr>
        );
      }
      return false;
    });
  }
  render() {
    const listOfUsers = (this.props.list && this.props.list.toJS()) || false;
    listOfUsers.sort(dynamicSort(this.state.orderBy));
    return (
      <div className={Styles.content}>
        <div className={Styles.actionBar}>
          <div className={Styles.searchBox}>
            <Input
              type="text"
              label="Search"
              icon="search"
              value={this.state.search}
              onChange={e => this.setState({ search: e })}
            />
          </div>
          <div className={Styles.actionBox}>
            <Dropdown
              label="Order by"
              auto
              onChange={orderBy => this.setState({ orderBy })}
              source={orderByStates}
              value={this.state.orderBy}
            />
          </div>
        </div>
        {this.state.showEdit && <Edit
          done={() => {
            this.toggleEdit();
          }}
          user={this.state.curUser}
        />}
        {this.state.showCreate && <Create
          done={() => {
            this.toggleCreate();
          }}
        />}
        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Users</div>
            <CardText className={Styles.usersContent}>
              <Checkbox
                checked={this.state.showInactiveUsers}
                label="Show inactive users"
                onChange={val => this.setState({ showInactiveUsers: val })}
              />
            </CardText>
            <table className={Styles.table}>
              <thead>
                <tr>
                  <th>
                    <div className={Styles.spacer} />
                  </th>
                  <th>Username</th>
                  <th>Name</th>
                  <th>Level</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{listOfUsers && this.renderUsers(listOfUsers)}</tbody>
            </table>
            <CardActions>
              <Button
                icon="create"
                label="Create user"
                primary
                onClick={() => {
                  this.toggleCreate();
                }}
              />
            </CardActions>
          </Card>
        </div>
        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Locations</div>
            <CardActions>
              <table className={Styles.table}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(this.props.locations).map(l => (
                    <tr key={l}>
                      <td>{this.props.locations[l].name}</td>
                      <td>No actions</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardActions>
          </Card>
        </div>

        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Refresh order by invoiceId</div>
            <div>
              <Input
                type="text"
                label="InvoiceId"
                icon="assignment"
                value={this.state.invoiceId}
                onChange={e =>
                  this.setState({ invoiceId: e.replace(/\D/, '') })
                }
              />
            </div>
            <CardActions>
              <Button
                icon="cached"
                label="Fetch order"
                primary
                onClick={() => {
                  this.fetchOrder();
                }}
              />
            </CardActions>
          </Card>
        </div>

        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Misc</div>
            <CardActions>
              <Button
                icon="dashboard"
                label="QR codes"
                primary
                onClick={() => {
                  const pdf = `${CONFIG.api_url}/pdf/qrList`;
                  window.open(pdf);
                }}
              />
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.getIn(['user', 'list'], {}),
  locations: state.getIn(['locations', 'locations']).toJS()
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps)(Users);



// WEBPACK FOOTER //
// ./app/pages/Admin/index.js